import {colorNames, useNamedColor} from '@github-ui/use-named-color'

import styles from './IssueTypeDot.module.css'

type IssueTypeDotProps = {color: string}

export const IssueTypeDot = ({color}: IssueTypeDotProps) => {
  const effectiveColor = colorNames.find(c => c === color)
  const {fg} = useNamedColor(effectiveColor)

  return <div style={{'--bg': `${fg}`} as React.CSSProperties} className={styles.issueTypeDot} />
}

try{ IssueTypeDot.displayName ||= 'IssueTypeDot' } catch {}